<template>
  <div>
    <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <div class="zj-left-header">
          <el-button type="text" @click="onAdd">新增</el-button>
        </div>
        <el-divider></el-divider>
        <div class="zj-left-main">
          <div style="height:450px;">
            <el-tree
              style="{ width }"
              :data="Orgs"
              :default-expanded-keys="expandkeys"
              :props="defaultProps"
              @node-click="handleNodeClick"
              default-expand-all="true"
              highlight-current="true"
            ></el-tree>
          </div>
        </div>
      </div>
      <div class="zj-layout-right">
        <div class="zj-layout-main">
          <el-container style="height: 450px;">
            <el-main>
              <el-form
                ref="orgform"
                status-icon
                :model="orgform"
                :rules="rules"
                label-width="100px"
              >
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="上级组织" prop="ParentOrgName">
                      <el-input v-model="orgform.ParentOrgName" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="组织code" prop="OrgCode">
                      <el-input v-model="orgform.OrgCode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="组织名称" prop="OrgName">
                      <el-input v-model="orgform.OrgName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="组织简称" prop="OrgShortName">
                      <el-input v-model="orgform.OrgShortName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="产品" prop="ProductIds">
                      <el-select v-model="orgform.ProductIds" multiple placeholder="请选择">
                        <el-option
                          v-for="item in Products"
                          :key="item.LogicId"
                          :label="item.ProductName"
                          :value="item.LogicId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="所属区域" prop="Area">
                      <el-cascader
                        ref="AreaCascader"
                        v-model="orgform.AreaID"
                        :options="Areas"
                        :props="AreasProps"
                        :show-all-levels="false"
                        filterable
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="20">
                    <el-form-item label="负责人" prop="PersonInCharge">
                      <el-input v-model="orgform.PersonInCharge"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="联系电话" prop="Phone">
                      <el-input v-model="orgform.Phone"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="是否企业" prop="IsCompanyTier">
                      <el-switch v-model="orgform.IsCompanyTier" :width="80"></el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="分管领导" prop="Leader">
                      <el-input v-model="orgform.Leader"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="部门地址" prop="DepartmentAddress">
                      <el-input v-model="orgform.DepartmentAddress"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="邮政编码" prop="PostalCode">
                      <el-input v-model="orgform.PostalCode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="备注" prop="Remark">
                      <el-input
                        type="textarea"
                        :rows="5"
                        v-model="orgform.Description"
                        maxlength="500"
                        show-word-limit
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-main>
            <el-footer style="text-align: center;">
              <el-button @click="onSave" :disabled="isDisabled">保存</el-button>
              <el-button @click="onDelete" :disabled="isDisabled">删除</el-button>
            </el-footer>
          </el-container>
        </div>
      </div>
    </zj-layout-container>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "OrgsPage",
  controller: "UI",
  action: "orgs",
  data() {
    return {
      Orgs: [],
      defaultProps: {
        children: "OrgInfos",
        label: "OrgName",
      },
      SelectedOrg: "",
      SelectedArea: "",
      IsUpdate: false,
      orgform: {
        ParentOrgId: "",
        ParentOrgName: "",
        OrgId: "",
        OrgCode: "",
        OrgName: "",
        ProductIds: "",
        OrgShortName: "",
        PersonInCharge: "",
        Phone: "",
        IsCompanyTier: false,
        Leader: "",
        DepartmentAddress: "",
        PostalCode: "",
        Description: "",
      },
      resData: "",
      Areas: [],
      AreasProps: {
        checkStrictly: true,
        emitPath: false,
        value: "TreeId",
        label: "TreeName",
        children: "ChildTreeList",
      },
      ProductsProps: {
        multiple: true,
        value: "LogicId",
        label: "ProductName",
      },
      expandkeys: [],
      Products: [],
    };
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    this.logInfo.ActionName = "组织机构查看";
    this.logInfo.LogMessage = "组织机构查看";
    this.logInfo.ModuleName = "权限管理";
    this.logInfo.PageName = "组织机构页面";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    init() {
      return utils.waitAll([
        () => this.GetOrgsByUserId(""),
        () => this.GetAreas(),
        () => this.GetProducts(),
      ]);
    },
    GetProducts() {
      let user = this.user;
      let userId = user.UserId;
      var Org_Code = this.config.app.org_code;
      showLoading(".zj-form-container");
      let ProductSearch = {
        OrgCode: Org_Code,
        LoginUserId: userId,
      };

      console.log(ProductSearch);

      return new WebApis.ProductApi()
        .GetProducts(ProductSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            this.Products = res.data.Data;
          }
          hideLoading();
        })
        .catch((e) => {
          console.log(e);
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg ? "获取产品失败!" + e.RspMsg : "获取产品失败!",
            type: "error",
          });
        });
    },
    GetAreas() {
      showLoading(".zj-form-container");
      return new WebApis.TreeApi()
        .GetAreaTree()
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            this.Areas = res.data.Data;
          }
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取行政区划失败!" + e.RspMsg
              : "获取行政区划失败!",
            type: "error",
          });
        });
    },
    GetOrgsByUserId(expand_keys) {
      let user = this.user;
      let userId = user.UserId;

      let TreeSearch = {
        UserId: userId,
      };
      showLoading(".zj-form-container");
      return new WebApis.TreeApi()
        .GetOrgTreeByUserId(TreeSearch)
        .then((res) => {
          hideLoading();
          this.Orgs = res.data.Data;
          this.expandkeys = expand_keys;
        })
        .catch((e) => {
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取组织机构失败!" + e.RspMsg
              : "获取组织机构失败!",
            type: "error",
          });
        });
    },
    handleNodeClick(data) {
      this.SelectedOrg = data;
      this.GetInfo();
    },
    GetParentOrg(OrgId, OrgTree) {
      if (
        OrgTree != null &&
        OrgTree.OrgInfos != null &&
        OrgTree != undefined &&
        OrgTree.OrgInfos != undefined
      ) {
        for (var i = 0; i < OrgTree.OrgInfos.length; i++) {
          if (OrgTree.OrgInfos[i].OrgId == OrgId) {
            if (OrgTree.Id == 0) {
              OrgTree = undefined;
            }

            return OrgTree;
          } else {
            var result = this.GetParentOrg(OrgId, OrgTree.OrgInfos[i]);
            if (result != null && result != null) {
              return result;
            }
          }
        }
      }
    },
    GetInfo() {
      if (this.SelectedOrg) {
        this.IsUpdate = true;
        showLoading(".zj-form-container");
        let OrgInfoSearch = {
          OrgId: this.SelectedOrg.OrgId,
        };

        new WebApis.OrgApi()
          .GetItemById(OrgInfoSearch)
          .then((res) => {
            let ParentOrg = this.GetParentOrg(
              this.SelectedOrg.OrgId,
              this.Orgs[0]
            );
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.orgform.ParentOrgId = ParentOrg ? ParentOrg.OrgId : "";
              this.orgform.ParentOrgName = ParentOrg ? ParentOrg.OrgName : "";
              this.orgform.OrgId = this.resData.OrgId;
              this.orgform.OrgCode = this.resData.OrgCode;
              this.orgform.OrgName = this.resData.OrgName;
              this.orgform.OrgShortName = this.resData.OrgShortName;
              this.orgform.PersonInCharge = this.resData.PersonInCharge;
              this.orgform.Phone = this.resData.Phone;
              this.orgform.AreaID = this.resData.AreaID;
              this.orgform.IsCompanyTier =
                this.resData.IsCompanyTier == 1 ? true : false;
              this.orgform.Leader = this.resData.Leader;
              this.orgform.DepartmentAddress = this.resData.DepartmentAddress;
              this.orgform.PostalCode = this.resData.PostalCode;
              this.orgform.Description = this.resData.Description;

              let OrgProductSearch = {
                OrgId: this.resData.OrgId,
              };
              new WebApis.OrgProductApi()
                .GetProductIdsByOrgId(OrgProductSearch)
                .then((res) => {
                  if (res.RspCode == "1") {
                    console.log(res.data.Data);
                    this.orgform.ProductIds = res.data.Data;
                  }
                })
                .catch((e) => {
                  console.log(e);
                  this.$message({
                    showClose: true,
                    message: e.RspMsg
                      ? "根据组织机构获取产品失败!" + e.RspMsg
                      : "根据组织机构获取产品失败!",
                    type: "error",
                  });
                });
            } else {
              this.IsUpdate = false;
              this.orgform.ParentOrgId = "";
              this.orgform.ParentOrgName = "";
              this.orgform.OrgId = "";
              this.orgform.OrgCode = "";
              this.orgform.OrgName = "";
              this.orgform.OrgShortName = "";
              this.orgform.PersonInCharge = "";
              this.orgform.Phone = "";
              this.orgform.AreaID = "";
              this.orgform.IsCompanyTier = false;
              this.orgform.Leader = "";
              this.orgform.DepartmentAddress = "";
              this.orgform.PostalCode = "";
              this.orgform.Description = "";
            }
            hideLoading();
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取组织机构信息失败!" + e.RspMsg
                : "获取组织机构信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    onAdd() {
      this.isDisabled = false;
      if (this.SelectedOrg) {
        this.IsUpdate = false;
        this.orgform.ParentOrgId = this.orgform.OrgId;
        this.orgform.ParentOrgName = this.orgform.OrgName;
        this.orgform.OrgId = "";
        this.orgform.OrgCode = "";
        this.orgform.OrgName = "";
        this.orgform.OrgShortName = "";
        this.orgform.PersonInCharge = "";
        this.orgform.Phone = "";
        this.orgform.IsCompanyTier = false;
        this.orgform.Leader = "";
        this.orgform.AreaID = "";
        this.orgform.DepartmentAddress = "";
        this.orgform.PostalCode = "";
        this.orgform.Description = "";
      } else {
        this.$message({
          showClose: true,
          message: "请选择父组织机构!",
          type: "error",
        });
      }
    },
    onSave() {
      let OrgInfoDTO = {
        Id: 0,
        OrgId: "",
        OrgCode: this.orgform.OrgCode,
        OrgName: this.orgform.OrgName,
        OrgShortName: this.orgform.OrgShortName,
        ParentOrgId: this.orgform.ParentOrgId,
        OrgTiers: "", //在后台计算
        PersonInCharge: this.orgform.PersonInCharge,
        Phone: this.orgform.Phone,
        Leader: this.orgform.Leader,
        DepartmentAddress: this.orgform.DepartmentAddress,
        PostalCode: this.orgform.PostalCode,
        AllowEdit: 0,
        AllowDelete: 0,
        AreaID: this.orgform.AreaID,
        IsCompanyTier: this.orgform.IsCompanyTier == true ? 1 : 0,
        Description: this.orgform.Description,
        Creater: this.user.UserName,
        CreateTime: new Date(),
        Modifier: this.user.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "",
        Extend2: "",
      };

      if (!this.IsUpdate) {
        this.onInsert(OrgInfoDTO);
      } else {
        OrgInfoDTO.Id = this.SelectedOrg.Id;
        OrgInfoDTO.OrgId = this.SelectedOrg.OrgId;
        OrgInfoDTO.Creater = this.SelectedOrg.Creater;
        OrgInfoDTO.CreateTime = this.SelectedOrg.CreateTime;
        OrgInfoDTO.Modifier = this.user.UserName;
        OrgInfoDTO.ModifyTime = new Date();
        this.onUpdate(OrgInfoDTO);
      }
    },
    onInsert(OrgInfoDTO) {
      showLoading(".zj-form-container");
      // var ProductIdstrs=[];
      // this.orgform.ProductIds.forEach(element => {
      //   ProductIdstrs.push(element[0])
      // });

      let OrgProductsDTO = {
        orgInfo: OrgInfoDTO,
        ProductIdList: this.orgform.ProductIds,
      };
      new WebApis.OrgApi()
        .AddItemAndProductList(OrgProductsDTO)
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            let OrgIdArray = [];
            var OrgId = res.data.Data;
            OrgIdArray.push(OrgId);
            this.$message({ message: "组织机构添加成功!", type: "success" });
            this.GetOrgsByUserId(OrgIdArray);
          } else {
            hideLoading();
            this.$message({
              showClose: true,
              message: "添加组织机构失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "组织机构添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "组织机构添加成功" : "添加组织机构失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "组织机构页面";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log(e);
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "添加组织机构失败！" + e.RspMsg
              : "添加组织机构失败！",
            type: "error",
          });
          return false;
        });
    },
    onUpdate(OrgInfoDTO) {
      showLoading(".zj-form-container");

      // var ProductIdstrs=[];
      // this.orgform.ProductIds.forEach(element => {
      //   ProductIdstrs.push(element[0])
      // });

      console.log(this.orgform.ProductIds);

      let OrgProductsDTO = {
        orgInfo: OrgInfoDTO,
        ProductIdList: this.orgform.ProductIds,
      };

      new WebApis.OrgApi()
        .UpdateItemAndProductList(OrgProductsDTO)
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            this.$message({ message: "组织机构修改成功!", type: "success" });
            let OrgIdArray = [];
            var OrgId = res.data.Data;
            OrgIdArray.push(OrgId);
            this.GetOrgsByUserId(OrgIdArray);
          } else {
            hideLoading();
            this.$message({
              showClose: true,
              message: "修改组织机构失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "组织机构修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "组织机构修改成功" : "修改组织机构失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "组织机构页面";
          this.addOperationLog();
        })
        .catch((e) => {
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "修改组织机构失败！" + e.RspMsg
              : "修改组织机构失败！",
            type: "error",
          });
          return false;
        });
    },
    canDelete(SelectedOrg, callback) {
      let canDelete = true;
      new WebApis.OrgApi()
        .FindByConditions({
          ParentOrgId: SelectedOrg.OrgId,
        })
        .then((r) => {
          var data = r.data.Data;
          if (data != null && data.length > 0) {
            this.$message.error(
              "该组织机构已维护了子组织信息，请先删除子组织。"
            );
            canDelete = false;
          }
          callback(canDelete);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onDelete() {
      if (this.SelectedOrg) {
        this.$confirm("此操作将永久删除该组织, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const that = this;
            that.canDelete(that.SelectedOrg, function (data) {
              if (data) {
                new WebApis.OrgApi()
                  .DelItem(that.SelectedOrg)
                  .then((r) => {
                    if (r.RspCode == "1") {
                      that.$message({ type: "success", message: "删除成功!" });
                      that.GetOrgsByUserId("");
                      that.orgform.ParentOrgId = "";
                      that.orgform.ParentOrgName = "";
                      that.orgform.OrgId = "";
                      that.orgform.OrgCode = "";
                      that.orgform.OrgName = "";
                      that.orgform.OrgShortName = "";
                      that.orgform.PersonInCharge = "";
                      that.orgform.Phone = "";
                      that.orgform.ProductIds= "";
                      that.orgform.AreaID = "";
                      that.orgform.IsCompanyTier = false;
                      that.orgform.Leader = "";
                      that.orgform.DepartmentAddress = "";
                      that.orgform.PostalCode = "";
                      that.orgform.Description = "";
                    } else {
                      that.$message({
                        showClose: true,
                        message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                        type: "error",
                      });
                    }
                    that.logInfo.ActionName = "组织机构删除";
                    that.logInfo.LogMessage =
                      r.RspCode == "1" ? "组织机构删除成功" : "删除组织机构失败";
                    that.logInfo.ModuleName = "权限管理";
                    that.logInfo.PageName = "组织机构页面";
                    that.addOperationLog();
                  })
                  .catch((e) => {
                    console.log(e);
                    that.$message({
                      showClose: true,
                      message: e.RspMsg
                        ? "删除失败!" + e.RspMsg
                        : "获取产品信息失败!",
                      type: "error",
                    });
                  });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    }
  },
};
</script>